import { Currencies } from '@constants/enums';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Currency } from '../../../components/common/Form/config';
import { LoadState } from '../../../pages/store/types';
import rateSvc from '../../../services/rate/rateSvc';
import { ExchangeResponse, IExchange } from '../../../services/rate/types';
import { camelCaseMapData } from '../../../utils/formater';

interface CurrencyExchange {
  rate: IExchange;
  currency: Currency;
}
type RateState = LoadState<CurrencyExchange[]>;
const CURRENCIES: Currency[] = [Currencies.MXN, Currencies.COP];

export const initialState: RateState = {
  error: '',
  loading: false,
  data: null,
};

const fetchExchange = async ({
  desCurrency,
  enterpriseId,
}: {
  desCurrency: Currency;
  enterpriseId: string;
}) => {
  const response = camelCaseMapData<ExchangeResponse, IExchange>(
    await rateSvc.getExchange({
      currency: Currencies.USD,
      desCurrency,
      enterpriseId,
    })
  );

  return new Promise((resolve) => {
    resolve({
      rate: response,
      currency: desCurrency,
    });
  });
};

// TODO: Remove it
const fetchExchangeCurrencies = createAsyncThunk(
  'fetchExchangeCurrencies',
  async (enterpriseId: string) =>
    Promise.all(
      CURRENCIES.map((currency) =>
        fetchExchange({ desCurrency: currency, enterpriseId })
      )
    ) as unknown as CurrencyExchange[]
);

export const exchangeSlice = createSlice({
  name: 'balance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchExchangeCurrencies.pending, (state) => {
      state.loading = true;
      state.error = '';
      state.data = null;
    });
    builder.addCase(
      fetchExchangeCurrencies.fulfilled,
      (state, { payload: exchange }) => {
        state.loading = false;
        state.data = exchange;
        state.error = '';
      }
    );

    builder.addCase(fetchExchangeCurrencies.rejected, (state) => {
      state.loading = false;
      state.data = null;
      state.error = 'ERROR';
    });
  },
});

export { fetchExchangeCurrencies };
export default exchangeSlice.reducer;
